<template>
  <div
    v-loading="loading"
    element-loading-background="rgba(24, 33, 48, 0.8)"
    class="flex flex-col gap-4"
  >
    <div class="text-xl font-bold">High Solar Radiation Detected</div>
    <div class="grid grid-cols-2 gap-4">
      <div class="flex flex-col gap-2">
        <div class="text-gray-300 font-bold">Associated Event</div>
        <div>#{{ model.event.id }}</div>
      </div>
      <div class="flex flex-col gap-2">
        <div class="text-gray-300 font-bold">Submission TimeStamp</div>
        <div>{{ model.audit.createdAt | datetime }}</div>
      </div>
      <div class="flex flex-col gap-2">
        <div class="text-gray-300 font-bold">Associated Event Name</div>
        <div>{{ model.event.name }}</div>
      </div>
      <div class="flex flex-col gap-2">
        <div class="text-gray-300 font-bold">Event Creation Timestamp</div>
        <div>{{ model.event.timestamp | datetime }}</div>
      </div>
    </div>
    <div class="flex flex-col gap-2">
      <div class="text-xl font-bold">Description</div>
      <div>
        {{ model.event.event || "No description available." }}
      </div>
    </div>
    <el-divider />
    <div class="text-xl font-bold">Provide Feedback</div>
    <div>Feedback Type</div>
    <div class="flex flex-row gap-4">
      <button
        class="flex-1 text-white bg-gray-600 rounded p-4"
        :class="{
          'bg-green-800 text-green-400': model.audit.type === 'True',
        }"
        @click="setType('True')"
      >
        <i class="fa fa-thumbs-up"></i> True
      </button>
      <button
        class="flex-1 text-white bg-gray-600 rounded p-4"
        :class="{
          'bg-red-800 text-red-400': model.audit.type === 'False',
        }"
        @click="setType('False')"
      >
        <i class="fa fa-thumbs-down"></i> False
      </button>
    </div>
    <el-form label-width="100px" label-position="top" class="flex-1">
      <el-form
        ref="feedbackForm"
        :model="model.audit"
        :rules="formRules"
        label-width="100px"
        label-position="top"
        class="flex-1"
      >
        <el-form-item
          label="Additional Details for False Events"
          v-if="model.audit.type === 'False'"
          prop="feedback"
        >
          <el-input
            type="textarea"
            v-model="model.audit.feedback"
            placeholder="Write feedback here..."
            :autosize="{ minRows: 6 }"
            class="w-full"
          />
        </el-form-item>
      </el-form>
    </el-form>
    <div class="flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2">
      <el-button @click="$emit('cancel')">Close</el-button>
      <el-button
        v-if="!isReadonly"
        type="primary"
        @click="handleSave"
        :loading="submitting"
      >
        {{ auditId ? "Save Feedback" : "Create Feedback" }}
      </el-button>
    </div>
  </div>
</template>

<script>
import {
  createAiAudit,
  updateAiAudit,
  getAiAuditById,
  getAllAssetVo,
  getAgents,
  getEvents,
} from "@/api";
import { mapGetters } from "vuex";

export default {
  name: "EditAIFeedback",
  components: {},
  emits: ["confirm", "cancel"],
  props: {
    auditId: {
      type: [String, Number, Object],
      default: null,
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      model: {
        audit: {
          id: undefined,
          eventId: null,
          agentId: null,
          deviceKey: null,
          type: "True",
          feedback: "",
          userId: "",
        },
        event: {
          id: null,
          userId: "",
          name: "",
          type: "",
          event: "",
          executionId: null,
          timestamp: 0,
          level: 0,
          status: 0,
          deviceKey: "",
          assetName: "",
          tagInfo: null,
          agentInfo: {},
        },
      },
      formRules: {
        feedback: [
          {
            required: true,
            message: "Feedback is required for False.",
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (this.model.audit.type === "False" && !value.trim()) {
                callback(new Error("Feedback is required for False."));
              } else {
                callback();
              }
            },
          },
        ],
      },
      submitting: false,
    };
  },
  computed: {
    ...mapGetters(["user"]),
    userId() {
      return this.user?.id || "2";
    },
  },
  methods: {
    getAllAssetVo,
    getAgents,
    getEvents,
    async fetchDataById(auditId) {
      if (!auditId) return;
      const me = this;
      me.loading = true;
      try {
        const { audit } = await getAiAuditById(auditId);
        me.model.audit = audit;
        me.model.event = audit.event || {};
      } finally {
        me.loading = false;
      }
    },
    setType(type) {
      this.model.audit.type = type;
      if (type !== "False") {
        this.model.audit.feedback = "";
      }
    },
    async handleSave() {
      const me = this;
      if (me.model.audit.type === "False") {
        await this.$refs.feedbackForm.validate();
      }
      me.submitting = true;
      try {
        const audit = me.model.audit;
        if (me.auditId) {
          await updateAiAudit(audit);
        } else {
          await createAiAudit(audit);
        }
        me.$emit("confirm", audit);
      } finally {
        me.submitting = false;
      }
    },
  },
  mounted() {
    const me = this;
    me.fetchDataById(me.auditId);
  },
};
</script>
<style scoped>
.edit-ai-feedback {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
